import { SearchVendorContainer } from 'src/containers';

export const SearchVendor = () => <SearchVendorContainer />;
